/**
 * BLOCO RENOV É PARTE DA RENOVAÇÃO (Douglas 18/10/2026: "tem que ter as linhas pra
 * renovar... temos o bloco de dados de incremento que é venda nova, e temos o bloco
 * de dados renovação, ele é usado para renovação").
 * A renovação leva as linhas renovadas, cada uma com o plano novo, e o bloco de
 * renovação junto. Sem linha de renovação na proposta o bloco não tem do que fazer
 * parte: quem quer bloco como venda nova usa o Bloco Incr.
 */
export function blocoRenovSemRenovacao(linhas: ReadonlyArray<{ tipo?: string | null; tipoBloco?: string | null }>): string | null {
  const temBlocoRenov = linhas.some((l) => l?.tipo === 'NOVA' && l?.tipoBloco === 'RENOVACAO');
  if (!temBlocoRenov) return null;
  if (linhas.some((l) => l?.tipo === 'RENOVACAO')) return null;
  return 'Bloco Renov só entra junto da renovação: adicione as linhas renovadas, cada uma com o plano novo. '
    + 'Bloco como venda nova é o Bloco Incr.';
}
